/**
 * Get prefixed date value based on whether the value is smaller then 10.
 * @param {Number} value
 * @returns {string}
 */
const getDateValue = value => (value < 10 ? `0${value}` : value);

/**
 * Return date as date string.
 * @param {Date} date
 * @returns {string}
 */
export default date => {
  const year = date.getFullYear();
  const month = getDateValue(date.getMonth() + 1);
  const day = getDateValue(date.getDate());

  return `${year}-${month}-${day}`;
};
